import * as React from "react";

function SvgFreeTimeDrawing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 618 591"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <g transform="translate(-107.76 -82.893)">
        <g
          id="free_time_drawing_svg__drawing"
          transform="matrix(.86228 -.8106 .81874 .87095 -338.049 446.264)"
        >
          <path
            d="M823.448 371.098c0-12.108-9.914-21.924-22.144-21.924H229.168l-86.314 44.878 86.314 37.714h572.136c12.23 0 22.144-9.815 22.144-21.924v-38.744z"
            fill="#fea09d"
          />
          <clipPath id="free_time_drawing_svg___clip1">
            <path d="M823.448 371.098c0-12.108-9.914-21.924-22.144-21.924H229.168l-86.314 44.878 86.314 37.714h572.136c12.23 0 22.144-9.815 22.144-21.924v-38.744z" />
          </clipPath>
          <g clipPath="url(#free_time_drawing_svg___clip1)">
            <path
              fill="#fe9592"
              d="M56.042 546.125H95.75v46.061H56.042z"
              transform="matrix(13.5176 -.06539 .00637 1.29081 -551.461 -293.514)"
            />
            <path
              fill="#feaeac"
              d="M56.042 546.125H95.75v46.061H56.042z"
              transform="matrix(13.5176 -.06539 .00637 1.29081 -551.365 -386.196)"
            />
            <path
              d="M94.126 547.835l-38.084-1.71v46.061l38.084 1.71 6.974-14.513v-14.674l-6.974-16.874z"
              fill="#feb4b2"
              transform="matrix(2.26896 -.0464 .04686 2.24638 -16.39 -889.588)"
            />
            <path
              fill="#fd6a66"
              d="M56.042 546.125H95.75v46.061H56.042z"
              transform="matrix(2.26942 -.01098 .01109 2.24683 613.809 -888.863)"
            />
            <g transform="matrix(2.26896 -.0464 .04686 2.24638 490.858 -891.834)">
              <path
                d="M101.674 547.757l6.974 16.875v14.673l-6.974 14.513-13.731.141 6.973-14.513v-14.674l-6.973-16.874 13.731-.141z"
                fill="#c45b5b"
              />
              <clipPath id="free_time_drawing_svg___clip2">
                <path d="M101.674 547.757l6.974 16.875v14.673l-6.974 14.513-13.731.141 6.973-14.513v-14.674l-6.973-16.874 13.731-.141z" />
              </clipPath>
              <g clipPath="url(#free_time_drawing_svg___clip2)">
                <path
                  fill="#be5050"
                  d="M56.042 546.125H95.75v46.061H56.042z"
                  transform="matrix(.56082 -.00297 .00176 .33285 57.221 397.794)"
                />
                <path
                  fill="#ca6666"
                  d="M56.042 546.125H95.75v46.061H56.042z"
                  transform="matrix(.56082 -.00297 .00176 .33285 56.213 367.77)"
                />
              </g>
            </g>
            <path
              d="M95.75 546.125H56.042v46.061H95.75c9.691-15.358 9.011-30.711 0-46.061z"
              fill="#c45b5b"
              transform="matrix(.73767 -.00357 .0036 .73033 96.704 -23.275)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgFreeTimeDrawing;
